import styled from 'styled-components';
import { Body2Styles } from '../typography';
import { getSizeBy, getColor, getColorShade } from '../../../src/styled/utils';
export const HiddenInput = styled.input `
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  cursor: inherit;
  opacity: 0;
`;
export const StyledCheckbox = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${getSizeBy(4)};
  height: ${getSizeBy(4)};
  background-color: ${({ disabled, checked, $filled }) => {
    if (disabled)
        return getColorShade('onSurface', 'hover');
    if (checked)
        return getColor('primary');
    if ($filled)
        return getColorShade('primary', 'hover');
    return 'transparent';
}};
  border: 1px solid;
  border-color: ${getColorShade('onSurface', 'outline')};
  border-radius: 3px;
  transition-duration: 200ms;
  transition-property: border-color, background-color;

  ${HiddenInput}:not(:disabled):checked + & {
    border-color: ${getColor('primary')};
  }

  ${HiddenInput}:focus:not(:disabled):not(:checked) + & {
    border-color: ${getColor('primary')};
  }

  svg {
    width: ${getSizeBy(2)};
    height: ${getSizeBy(2)};
    visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};

    path,
    rect {
      fill: ${({ disabled }) => disabled
    ? getColorShade('onSurface', 'mediumEmphasis')
    : getColorShade('onPrimary', 'mediumEmphasis')};
    }

    rect {
      width: ${getSizeBy(2)};
      height: ${getSizeBy(0.5)};
    }
  }
`;
export const StyledLabel = styled.label `
  ${Body2Styles};
  position: relative;
  display: grid;
  grid-column-gap: ${getSizeBy(3)};
  grid-template-columns: max-content auto;
  align-items: center;
  color: ${({ disabled }) => getColorShade('onSurface', disabled ? 'lowEmphasis' : 'mediumEmphasis')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition-duration: 200ms;
  transition-property: color;
  user-select: none;

  &:hover {
    color: ${({ disabled }) => !disabled && getColor('onSurface')};
  }

  &:focus-within {
    color: ${getColor('onSurface')};
  }
`;
export const StyledLabelCheckbox = styled(StyledLabel) `
  &:hover ${StyledCheckbox} {
    background-color: ${({ checked, disabled }) => !checked && !disabled && getColorShade('primary', 'hover')};
    border-color: ${({ checked, disabled }) => !checked && !disabled && getColorShade('onSurface', 'mediumEmphasis')};
  }
`;
// --- NEW CHECKBOX ---
export const StyledNewRootCheckbox = styled.span `
  position: relative;
  display: inline-flex;
  padding: ${getSizeBy(1.75)};
  color: ${({ disabled }) => getColorShade('onSurface', disabled ? 'lowEmphasis' : 'mediumEmphasis')};
  background-color: transparent;
  border: 1px solid;
  border-color: transparent;
  border-radius: 50%;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition-duration: 200ms;
  transition-property: color background-color border-color;
  user-select: none;

  &:hover {
    color: ${({ disabled }) => !disabled && getColor('onSurface')};
    background-color: ${({ disabled }) => !disabled && getColorShade('primary', 'hover')};
  }

  &:active {
    background-color: ${({ disabled }) => !disabled && getColorShade('primary', 'pressed')};
  }

  &:focus-within {
    color: ${getColor('onSurface')};
    background-color: ${getColorShade('primary', 'hover')};
    border-color: ${getColorShade('primary', 'focused')};
  }
`;
export const NewHiddenInputCheckbox = styled.input.attrs({ type: 'checkbox' }) `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: inherit;
  opacity: 0;
`;
export const NewStyledCheckbox = styled.span `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${getSizeBy(4)};
  height: ${getSizeBy(4)};
  background-color: ${({ disabled, checked, $filled }) => {
    if (disabled)
        return getColorShade('onSurface', 'hover');
    if (checked)
        return getColor('primary');
    if ($filled)
        return getColorShade('primary', 'pressed');
    return 'transparent';
}};
  border: 1px solid;
  border-color: ${getColorShade('onSurface', 'outline')};
  border-radius: 3px;
  transition-duration: 200ms;
  transition-property: border-color, background-color;

  ${NewHiddenInputCheckbox}:not(:disabled):checked + & {
    border-color: ${getColor('primary')};
  }

  svg {
    width: ${getSizeBy(2)};
    height: ${getSizeBy(2)};
    visibility: ${({ checked }) => (checked ? 'visible' : 'hidden')};

    path,
    rect {
      fill: ${({ disabled }) => disabled
    ? getColorShade('onSurface', 'mediumEmphasis')
    : getColorShade('onPrimary', 'mediumEmphasis')};
    }

    rect {
      width: ${getSizeBy(2)};
      height: ${getSizeBy(0.5)};
    }
  }
`;
